import React, { useState } from 'react';
import './VeiculoseciaContato.scss';
import formImg from '../../../assets/images/contato/truck-contato2.jpg';
import contatoBanner from '../../../assets/images/contato/truck-contato.jpg';
import { ParallaxBanner, ParallaxProvider } from 'react-scroll-parallax';
import { FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { BsFillTelephoneFill } from 'react-icons/bs';
import toast from 'react-hot-toast';
import emailjs from '@emailjs/browser';
import { TextField, Button } from '@mui/material';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask'; 

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
        <IMaskInput
            {...other}
            inputRef={ref} 
            mask='(00) 00000-0000' 
            definitions={{
                '0': /[0-9]/,
            }}
            onAccept={(value, mask) => {
                onChange({
                    target: {
                        name: props.name,
                        value: value,
                    },
                });
            }}
            // Caso queira um caractere placeholder diferente do padrão '_'
            placeholderChar='_'
            // Garante que a digitação substitua os caracteres existentes da máscara
            overwrite
        />
    );
});

TextMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

function VeiculoseciaContato() {
    const [nome, setNome] = useState('');
    const [celular, setCelular] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    function IsEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    function sendEmail(e) {
        e.preventDefault();
        if (nome === '' || celular === '' || email === '' || message === '') {
            toast('Preencha todos os campos!', {
                icon: '⚠️',
            });
            return;
        }

        const emailValid = IsEmail(email);

        if (nome !== '' && celular[14] !== '_' && emailValid !== false && message !== '') {
            const serviceId = process.env.REACT_APP_SERVICE_ID;
            const templateId = process.env.REACT_APP_TEMPLATE_ID;
            const userId = process.env.REACT_APP_USER_ID;

            const templateParams = {
                from_name: nome,
                phone: celular,
                message: message,
                email: email
            }

            emailjs.send(serviceId, templateId, templateParams, userId).then((response) => {
                toast.success('Mensagem enviada!');
                setNome('');
                setCelular('');
                setEmail('');
                setMessage('');
            }, (err) => {
                toast.error('Algo deu errado! Tente enviar novamente!');                
            })
        } else {
            toast.error('Preenchimento inválido!');
            return;
        }
    }

    return (
        <>
            <ParallaxProvider>
                <ParallaxBanner
                    layers={[{ image: contatoBanner, speed: 10 }]}
                >
                    <div className='position-relative inset-0 flex items-center justify-center' style={{ height: '300px' }}>
                        <div className='veiculosecia__content d-flex flex-column justify-content-center h-100'>
                            <h6 className='text-8xl text-white' style={{ fontSize: '20px', fontWeight: 700, textAlign: 'center' }}>Fale Conosco</h6>
                        </div>
                    </div>
                </ParallaxBanner>
            </ParallaxProvider>
            <div className='veiculosecia__content'>
                <div className='contato'>
                    <div className='contato__cards'>
                        <div className='contato__card'>
                            <div className='card__single'>
                                <span className='contato__icon'><FaMapMarkerAlt /></span>
                                <p>Endereço:</p>
                                <h3>BR 364 Perímetro Urbano de Jaciara,<br />Jaciara - MT, CEP: 78820-000</h3>
                            </div>
                        </div>
                        <div className='contato__card'>
                            <div className='card__single'>
                                <span className='contato__icon'><BsFillTelephoneFill /></span>
                                <p>Telefone:</p>
                                <h3>(66) 3461-7500</h3>
                            </div>
                        </div>
                        <div className='contato__card'>
                            <div className='card__single'>
                                <span className='contato__icon'><FaWhatsapp /></span>
                                <p>Celular:</p>
                                <h3>(66) 99981-5612</h3>
                            </div>
                        </div>
                        <div className='contato__card'>
                            <div className='card__single'>
                                <span className='contato__icon'><MdEmail /></span>
                                <p>E-mail:</p>
                                <h3>veiculoseciamt@gmail.com</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-white'>
                <div className='veiculosecia__content'>
                    <section className='contato'>
                        <h6 style={{ fontWeight: 700, fontSize: '20px', textAlign: 'center' }} >Entrar em contato</h6>
                        <div className='row'>
                            <div className='contato__left col-md-5'>
                                <img src={formImg} alt='Caminhão' />
                            </div>
                            <div className='contato__right col-md-7 position-relative'>
                                <form className='right__content' onSubmit={sendEmail}>
                                    {/* Nome */}
                                    <TextField
                                        fullWidth 
                                        variant='standard'
                                        label='Nome'
                                        value={nome}
                                        onChange={(e) => setNome(e.target.value)}
                                        sx={{ mb: 3 }}
                                        size='small'
                                    />

                                    {/* Celular com Máscara */}
                                    <TextField
                                        fullWidth
                                        variant='standard'
                                        label='Celular'
                                        value={celular}
                                        onChange={(e) => setCelular(e.target.value)}
                                        InputProps={{ 
                                            inputComponent: TextMaskCustom, 
                                        }}
                                        sx={{ mb: 3 }}
                                        size='small'
                                    />

                                    {/* E-mail */}
                                    <TextField
                                        fullWidth
                                        variant='standard'
                                        label='E-mail'
                                        type='email' 
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        sx={{ mb: 3 }}
                                    />

                                    {/* Mensagem (TextArea) */}
                                    <TextField
                                        fullWidth
                                        variant='standard'
                                        label='Digite sua mensagem...'
                                        multiline 
                                        rows={4} 
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        sx={{ mb: 3 }}
                                        size='small'
                                    />

                                    {/* Botão de Enviar */}
                                    <Button
                                        variant='contained'
                                        type='submit'
                                        sx={{
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            '&:hover': {
                                                backgroundColor: '#0056b3',
                                            },
                                            mt: 2,
                                            height: '50px',
                                            fontSize: '1rem'
                                        }}
                                    >
                                        Enviar
                                    </Button>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3836.3159925142118!2d-54.982112124109!3d-15.944866326679842!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9377979ef0265707%3A0xb335d5fcce66b046!2sMartelli%20Transportes!5e0!3m2!1spt-BR!2sbr!4v1705341706590!5m2!1spt-BR!2sbr' width='100%' height='600' style={{ border: '0' }} allowFullScreen='' loading='lazy' referrerPolicy='no-referrer-when-downgrade' />
        </>
    )
}

export default VeiculoseciaContato;